import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/shared/lib/query-client';
import { KeycloakProvider } from './KeycloakProvider';
import { ThemeProvider } from './ThemeProvider';
import { NotificationProvider } from '@/features/notifications';
import { useThemeStore, getEffectiveTheme } from '@/features/theme';
import { useAiAvailabilityPoll } from '@/features/ai-assistant';
import { ConfirmDialogHost, Toaster, TooltipProvider } from '@/shared/ui';

interface AppProvidersProps {
  children: React.ReactNode;
}

const ThemedToaster: React.FC = () => {
  const mode = useThemeStore((s) => s.mode);
  return <Toaster theme={mode === 'system' ? getEffectiveTheme() : mode} />;
};

const AiAvailabilityPoll: React.FC = () => {
  useAiAvailabilityPoll();
  return null;
};

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <KeycloakProvider>
        <TooltipProvider delay={300} closeDelay={100}>
          <AiAvailabilityPoll />
          <NotificationProvider>{children}</NotificationProvider>
          <ThemedToaster />
          <ConfirmDialogHost />
        </TooltipProvider>
      </KeycloakProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
